import { Loader, MantineSize } from "@mantine/core";

interface IVojomoLoaderProps {
  size?: MantineSize | (string & {}) | number;
}

export const VojomoLoader = ({
  props,
  style
}: {
  props?: IVojomoLoaderProps;
  style?: React.CSSProperties;
}) => {
  return (
    <div
      className="flex justify-center items-center"
      style={{ height: "17.5vh" }}
    >
      <Loader color="#2c1561" size={props?.size || "xl"} style={{ ...style }} />
    </div>
  );
};
